<template>
<div>
        <!-- 互联电子评标工具目录 -->
        <div class="box2">
            <div class="box2-top">
                <mytitle :title="title" color="white" style="margin-top: 64px;"></mytitle>
                <div class="search">
                    <el-input v-model="PlatformParms.platformName" :placeholder="placeholder"
                        class="paperview-input-text" />
                    <el-button type="primary" class="searchbtn"
                        >搜索</el-button>
                </div>
            </div>

            <!-- 未搜索 -->
            <div class="content" v-if="!isSearch">
                <div class="platformtype-title" style="border-bottom: 1px solid #EBEBED;">省级（{{ platformList.length }}）</div>
                <div class="contentbox">

                    <div v-for="item in platformList" @mouseover="item.isHovered = true"
                        @mouseout="item.isHovered = false" @click="toPlatform(item.firstPlatform)"
                        style="cursor: pointer;">
                        <div class="center" v-show="!item.isHovered">
                            <img :src=item.firstPlatform.platformLogo alt="" class="appimgbox" :style="type === '1' && 'height: 40px;'">
                            <img src="../../assets/img/tradingSystem/new-tag.png" alt="" class="new-tag"
                                v-if="item.isNew">
                        </div>
                        <div class="center2" v-show="item.isHovered">
                            <div class="top2">
                                <img :src=item.firstPlatform.platformLogo alt="" class="appimgn" :style="type === '1' && 'height: 40px;padding: 20px 0;'">
                            </div>
                            <div class="infobox">


                                <div class="text-box1">
                                    {{ item.firstPlatform.platformContactName }}
                                </div>

                                <div class="text-box">
                                    {{ item.firstPlatform.platformContactPhone }}
                                </div>





                            </div>


                            <div style="display: flex;align-items: center;margin-top: 10px;">
                                <img src="../../assets/img/bidEvaluationTools/time.png" alt=""
                                    style="width: 14px;height: 14px;">
                                <span class="info-text3" style="margin-left: 3px;">{{ item.firstPlatform.createTime
                                    }}</span>
                            </div>




                        </div>
                    </div>





                    <div style="cursor: pointer;" v-for="n in noreginList" :key="n">
                        <div class="center">

                            <div class="noplatform">{{ n.title }}</div>

                        </div>

                    </div>



                </div>

                <div class="platformtype-title" style="margin-top: 16px;">地级市（{{ total }}）</div>

                <div v-for="(item, index) in cityList" :key="index">
                    <div class="municipality-title">

                        <div class="municipality-name">{{ item.provinceName ? item.provinceName : item.title }}</div>
                        <div class="municipality-total"> 共加入 {{ item.platformList.length }} 家</div>
                    </div>

                    <div style="width: 1200px;margin-left: -27px;" @mouseenter="item.isHovered2 = true"
                        @mouseleave="item.isHovered2 = false">
                        <div style="position: relative;width: 1153px;margin: 0 auto;">
                            <div class="contentbox2">

                                <swiper :slidesPerView="6" :spaceBetween="0" :autoplay="{
                                    delay: 2500,
                                    disableOnInteraction: false
                                }" :loop="true" :navigation="navigation" :modules="modules" class="mySwiper"
                                    v-if="item.platformList.length > 6">


                                    <swiper-slide v-for="(item2, index) in item.platformList"
                                        @mouseover="item2.isHovered = true" :key="index"
                                        @mouseout="item2.isHovered = false" @click="toPlatform(item2)"
                                        style="cursor: pointer;">
                                        <div class="center" v-show="!item2.isHovered">
                                            <img :src=item2.platformLogo alt="" class="appimgbox" :style="type === '1' && 'height: 40px;'">
                                            <img src="../../assets/img/tradingSystem/new-tag.png" alt="" class="new-tag"
                                                v-if="item2.isNew">


                                            <div class="cityName" v-if="showcity(item2.platformRegionName)">{{
                                                showcity(item2.platformRegionName) }}</div>
                                        </div>
                                        <div class="center2" v-show="item2.isHovered">
                                            <div class="top2">
                                                <img :src=item2.platformLogo alt="" class="appimgn">
                                            </div>
                                            <div class="infobox">
                                                <div class="text-box1">
                                                    {{ item2.platformContactName }}
                                                </div>

                                                <div class="text-box">
                                                    {{ item2.platformContactPhone }}
                                                </div>
                                            </div>


                                            <div style="display: flex;align-items: center;margin-top: 10px;">
                                                <img src="../../assets/img/bidEvaluationTools/time.png" alt=""
                                                    style="width: 14px;height: 14px;">
                                                <span class="info-text3" style="margin-left: 3px;">{{
                                                    item2.createTime
                                                    }}</span>
                                            </div>

                                        </div>
                                    </swiper-slide>
                                </swiper>






                                <div v-for="(item2, index2) in item.platformList" :key="index2"
                                    @mouseover="item2.isHovered = true" @mouseout="item2.isHovered = false"
                                    @click="toPlatform(item2)" style="cursor: pointer;"
                                    v-if="item.platformList.length <= 6">
                                    <div class="center" v-show="!item2.isHovered">
                                        <img :src=item2.platformLogo alt="" class="appimgbox" :style="type === '1' && 'height: 40px;'">
                                        <img src="../../assets/img/tradingSystem/new-tag.png" alt="" class="new-tag"
                                            v-if="item2.isNew">

                                        <div class="cityName" v-if="showcity(item2.platformRegionName)">{{
                                            showcity(item2.platformRegionName) }}</div>



                                    </div>
                                    <div class="center2" v-show="item2.isHovered">
                                        <div class="top2">
                                            <img :src=item2.platformLogo alt="" class="appimgn">
                                        </div>
                                        <div class="infobox">


                                            <div class="text-box1">
                                                {{ item2.platformContactName }}
                                            </div>

                                            <div class="text-box">
                                                {{ item2.platformContactPhone }}
                                            </div>





                                        </div>


                                        <div style="display: flex;align-items: center;margin-top: 10px;">
                                            <img src="../../assets/img/bidEvaluationTools/time.png" alt=""
                                                style="width: 14px;height: 14px;">
                                            <span class="info-text3" style="margin-left: 3px;">{{
                                                item2.createTime
                                                }}</span>
                                        </div>




                                    </div>
                                </div>




                                <div v-for="(item2, index3) in 6" :key="index3" style="cursor: pointer;"
                                    v-if="item.platformList.length < 6">
                                    <div class="center">
                                        <img src='../../assets/img/tradingSystem/npapp.png' alt="" class="appimg3"
                                            style="border:none">
                                    </div>

                                </div>












                            </div>

                            <div class="swiper-button-prev " @click.stop="prevEl(item, index)"
                                v-show="item.platformList.length > 6 && item.isHovered2">
                                <div class="delStep" style="position: absolute; left: -35px;top: 5px;"
                                    @click="prevCarousel">
                                    <img src="../../assets/img/delstep.svg" alt="" style="width: 16px;height: 16px;">
                                </div>
                            </div>
                            <div class="swiper-button-next swiper-button-next1" @click.stop="nextEl"
                                v-show="item.platformList.length > 6 && item.isHovered2">
                                <div class="delStep" style="position: absolute; right: -35px;top: 5px;"
                                    @click="addstep">
                                    <img src="../../assets/img/addstep.svg" alt="" style="width: 16px;height: 16px;">

                                </div>
                            </div>
                        </div>
                    </div>


                </div>


                <!-- <div style="cursor: pointer;" v-for="n in noreginList" :key="n">


                    <div class="municipality-title">
                        <div class="municipality-name">{{ n.title }}</div>
                        <div class="municipality-total"> 共加入 0 家</div>
                    </div>


                    <div class="contentbox2">

                        <div v-for="item in 6" style="cursor: pointer;">
                            <div class="center">

                                <img src='../../assets/img/tradingSystem/npapp.png' alt="" class="appimg3"
                                    style="border:none">


                            </div>

                        </div>









                    </div>



                </div> -->








            </div>


            <!-- 搜索后 -->


            <div class="content" v-if="isSearch">

                <div class="searchBox" v-if="searchPlatform.length > 0">
                    <div v-for="(item2, index2) in searchPlatform" :key="index2" @mouseover="item2.isHovered = true"
                        @mouseout="item2.isHovered = false" @click="toPlatform(item2)" style="cursor: pointer;">
                        <div class="center" v-show="!item2.isHovered">
                            <img :src=item2.platformLogo alt="" class="appimgbox" :style="type === '1' && 'height: 40px;'">
                        </div>
                        <div class="center2" v-show="item2.isHovered">
                            <div class="top2">
                                <img :src=item2.platformLogo alt="" class="appimgn">
                            </div>
                            <div class="infobox">


                                <div class="text-box1">
                                    {{ item2.platformContactName }}
                                </div>

                                <div class="text-box">
                                    {{ item2.platformContactPhone }}
                                </div>





                            </div>


                            <div style="display: flex;align-items: center;margin-top: 10px;">
                                <img src="../../assets/img/bidEvaluationTools/time.png" alt=""
                                    style="width: 14px;height: 14px;">
                                <span class="info-text3" style="margin-left: 3px;">{{
                                    item2.createTime
                                    }}</span>
                            </div>




                        </div>
                    </div>
                </div>

                <div class="btnmore" @click="addPage(PlatformParms.platformName)" v-if="showmoreBtn">
                    查看更多
                </div>




                <div v-if="searchPlatform.length < 1" class="nodata">
                    <img src="../../assets/img/tradingSystem/noimg.png" alt="" style="width: 80px;height: 80px;">
                    <div class="text1">暂无内容</div>
                    <div class="text2">没有搜到想要的内容？您可 联系我们 进行咨询</div>

                </div>




            </div>







        </div>

        <div style="height: 66px;width: 100px;"></div>
</div>
</template>

<script lang='ts' setup>
import { reactive, toRefs, ref,onMounted,defineProps} from 'vue' 
import mytitle from '../title.vue'

const props = defineProps({
    title: {
        type: String,
        default: ''
    },

    placeholder: {
        type: String,
        default: ''
    },
    type: {
        type: String,
        default: ''
    }
})

let total = ref(0)

onMounted(() => {
    noreginList.value = reginList.value
    let aa = JSON.parse(JSON.stringify(reginList.value))
    aa.map(item => {
        item.platformList = []
    }
    )
    cityList.value = aa
})
let PlatformParms = ref({
    platformName: '',
})
//地级市
let reginList = ref(
    [
        {
            "id": 11,
            "parentId": 0,
            "title": "北京市",
            "key": "11",
            "value": "11",
            "hasChildren": true
        },
        {
            "id": 12,
            "parentId": 0,
            "title": "天津市",
            "key": "12",
            "value": "12",
            "hasChildren": true
        },
        {
            "id": 13,
            "parentId": 0,
            "title": "河北省",
            "key": "13",
            "value": "13",
            "hasChildren": true
        },
        {
            "id": 14,
            "parentId": 0,
            "title": "山西省",
            "key": "14",
            "value": "14",
            "hasChildren": true
        },
        {
            "id": 15,
            "parentId": 0,
            "title": "内蒙古",
            "key": "15",
            "value": "15",
            "hasChildren": true
        },
        {
            "id": 21,
            "parentId": 0,
            "title": "辽宁省",
            "key": "21",
            "value": "21",
            "hasChildren": true
        },
        {
            "id": 22,
            "parentId": 0,
            "title": "吉林省",
            "key": "22",
            "value": "22",
            "hasChildren": true
        },
        {
            "id": 23,
            "parentId": 0,
            "title": "黑龙江省",
            "key": "23",
            "value": "23",
            "hasChildren": true
        },
        {
            "id": 31,
            "parentId": 0,
            "title": "上海市",
            "key": "31",
            "value": "31",
            "hasChildren": true
        },
        {
            "id": 32,
            "parentId": 0,
            "title": "江苏省",
            "key": "32",
            "value": "32",
            "hasChildren": true
        },
        {
            "id": 33,
            "parentId": 0,
            "title": "浙江省",
            "key": "33",
            "value": "33",
            "hasChildren": true
        },
        {
            "id": 34,
            "parentId": 0,
            "title": "安徽省",
            "key": "34",
            "value": "34",
            "hasChildren": true
        },
        {
            "id": 35,
            "parentId": 0,
            "title": "福建省",
            "key": "35",
            "value": "35",
            "hasChildren": true
        },
        {
            "id": 36,
            "parentId": 0,
            "title": "江西省",
            "key": "36",
            "value": "36",
            "hasChildren": true
        },
        {
            "id": 37,
            "parentId": 0,
            "title": "山东省",
            "key": "37",
            "value": "37",
            "hasChildren": true
        },
        {
            "id": 41,
            "parentId": 0,
            "title": "河南省",
            "key": "41",
            "value": "41",
            "hasChildren": true
        },
        {
            "id": 42,
            "parentId": 0,
            "title": "湖北省",
            "key": "42",
            "value": "42",
            "hasChildren": true
        },
        {
            "id": 43,
            "parentId": 0,
            "title": "湖南省",
            "key": "43",
            "value": "43",
            "hasChildren": true
        },
        {
            "id": 44,
            "parentId": 0,
            "title": "广东省",
            "key": "44",
            "value": "44",
            "hasChildren": true
        },
        {
            "id": 46,
            "parentId": 0,
            "title": "海南省",
            "key": "46",
            "value": "46",
            "hasChildren": true
        },
        {
            "id": 45,
            "parentId": 0,
            "title": "广西",
            "key": "45",
            "value": "45",
            "hasChildren": true
        },

        {
            "id": 50,
            "parentId": 0,
            "title": "重庆市",
            "key": "50",
            "value": "50",
            "hasChildren": true
        },
        {
            "id": 51,
            "parentId": 0,
            "title": "四川省",
            "key": "51",
            "value": "51",
            "hasChildren": true
        },
        {
            "id": 52,
            "parentId": 0,
            "title": "贵州省",
            "key": "52",
            "value": "52",
            "hasChildren": true
        },
        {
            "id": 53,
            "parentId": 0,
            "title": "云南省",
            "key": "53",
            "value": "53",
            "hasChildren": true
        },
        {
            "id": 54,
            "parentId": 0,
            "title": "西藏",
            "key": "54",
            "value": "54",
            "hasChildren": true
        },
        {
            "id": 61,
            "parentId": 0,
            "title": "陕西省",
            "key": "61",
            "value": "61",
            "hasChildren": true
        },
        {
            "id": 62,
            "parentId": 0,
            "title": "甘肃省",
            "key": "62",
            "value": "62",
            "hasChildren": true
        },
        {
            "id": 63,
            "parentId": 0,
            "title": "青海省",
            "key": "63",
            "value": "63",
            "hasChildren": true
        },
        {
            "id": 64,
            "parentId": 0,
            "title": "宁夏",
            "key": "64",
            "value": "64",
            "hasChildren": true
        },
        {
            "id": 65,
            "parentId": 0,
            "title": "新疆",
            "key": "65",
            "value": "65",
            "hasChildren": true
        },


        {
            "id": 99,
            "parentId": 0,
            "title": "新疆兵团",
            "key": "99",
            "value": "99",
            "hasChildren": true
        },


    ])


//地级市
let noreginList = ref([])

//省级

let platformList = ref([
  {
    createTime: "2024-12-19 09:15:44",
    provinceName: "湖北省",
    provinceCode: "42",
    isNew: true,
    sort: 5,
    platformList: [],
    firstPlatform: {
      id: "1869552157550780418",
      platformCode: "",
      platformName: "湖北省电子招投标交易平台",
      platformUrl: "",
      platformOrgName: "湖北省公共资源交易中心",
      platformOrgCode: "12420000767423658J",
      platformContactName: !props.type ? "李炜" : "何处",
      platformContactPhone: !props.type ? "13886032676" : "15392940611",
      platformLogo: props.type === '1' ? require("@/assets/img/hblogo1.png") : props.type === '2' ? require("@/assets/img/hblogo2.png") : require("@/assets/img/image.png"),
      createUserName: "",
      updateUserName: "",
      createTime: props.type === '1' ? "2025/03/30 11:20:35" : props.type === '2' ? "2025/03/30 12:25:28" : "2025/03/30 18:30:56",
      platformRegionName: "湖北省",
    },
  },
]);
noreginList.value = reginList.value.filter(
  (item) => !platformList.value.some((item2) => item2.provinceCode == item.key)
);
let cityList = ref([{ platformList: [] }])
</script>
<style lang="scss" scoped>


.banner {
    width: 100%;
    height: 577px;
    position: relative;
    background: url('../../assets/img/banner2/1-1.png') no-repeat center center;
    background-size: cover;


    .banner-center{
        width: 1200px;
        position: absolute;
        left: 50%;
        top: 116px;
        transform: translate(-50%);
        display: flex;
        justify-content: space-between;
    }


    .textbox {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .banner-img{
        height: 400px;
        margin-right: -124px;
        margin-top: 50px;
    }

    .banner-text1 {
        color: var(--Color-Neutral-neutral-11, #323335);
        
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: 70px;
        text-align: left
    }

    .banner-text2 {
        color: var(--Color-Neutral-neutral-10, #64666B);
        text-align: center;
        
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        text-align: left
    }


}

.box1 {
    // background: #F8F9FF;
    width: 100%;
    height: 550px;
    padding: 1px 0 0 0;



}

:deep(.el-input__wrapper) {
    box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
    cursor: default;
    border: none !important;

}

.box2 {
    width: 100%;

    .box2-top {
        width: 100%;
        height: 311px;
        background: url('../../assets/img/banner/search.webp') no-repeat center center;
        background-size: 100% 100%;
        padding: 1px;
        box-sizing: border-box;

        .search {
            width: 600px;
            margin: 0 auto;
            display: flex;
            height: 42px;
            background: #fff;
            align-items: center;
            border-radius: var(--Radius-Border-radius-3, 4px);
            padding: 0 3px 0 10px;
            margin-top: 48px;


        }


    }



    .platformtype-title {
        height: 48px;
        color: #000;
        
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 48px;
        // margin-top: 6px;
    }






    .content {
        width: 1200px;
        margin: 0 auto;

        border-radius: var(--Radius-Border-radius-3, 4px);
        border: var(--Radius-Border-radius-2, 2px) solid #FFF;
        background-color: #FFF;
        box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.10);
        margin-top: -40px;
        padding: 0 24px 32px 24px;
        box-sizing: border-box;


        .contentbox {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;

      .center {
        width: 267px;
        height: 166px;
        overflow: hidden;
        display: flex;
        border-radius: 8px;
        border: 1px solid #ebebed;
        /* 设置为Flex容器 */
        justify-content: center;
        /* 水平居中子元素 */
        align-items: center;
        /* 垂直居中子元素 */
        padding: 24px;
        box-sizing: border-box;
        position: relative;
        margin-top: 24px;

        .new-tag {
          position: absolute;
          top: 0;
          right: 0;
          width: 90px;
          height: 22px;
        }
      }

      .center2 {
        width: 276px;
        height: 190px;
        padding: 20px 15px;
        box-sizing: border-box;
        border-radius: var(--Radius-Border-radius-4, 8px);
        border: var(--Radius-Border-radius-2, 2px) solid var(--Text-Text-4, #f4f4f5);
        background: #fff;
        box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);

        .top2 {
          width: 100%;
          text-align: center;
          box-sizing: border-box;
          display: flex;
          margin: 5px;
        }

        .appimgn {
          // width: 162px;
          max-width: 144px;
          height: 80px;
          margin: 0 auto;
          margin-top: 0 !important;
        }

        .text0 {
          color: var(--Color-Neutral-neutral-10, #64666b);

          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 0.028px;
          margin-top: 20px;
        }

        .text1 {
          color: var(--Color-Neutral-neutral-10, #64666b);

          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 0.028px;
          display: flex;
        }

        .text2 {
          color: var(--Color-Neutral-neutral-9, #969aa0);

          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          display: flex;
        }

        .text3 {
          color: var(--Color-Branding-blue, #3461ff);

          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          width: 60px;
          text-align: right;
          cursor: pointer;
        }
      }

      .noplatform {
        color: #bfc1c5;
        text-align: center;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px;
      }
    }

        .municipality-title {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #EBEBED;
            padding: 16px 48px 0 24px;
            box-sizing: border-box;
            align-items: center;


            .municipality-name {
                color: var(--Text-neutral-11, #323335);
                
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 36px;
            }

            .municipality-total {
                color: #4B5B76;
                
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 22px;
            }
        }


        .contentbox2 {
            display: flex;
            // margin-top: 5px;
            // overflow: hidden;
            overflow-x: clip;
            width: 1153px;

            .center {
                width: 267px;
                height: 204px;
                // overflow: hidden;
                overflow-x: clip;
                border-radius: 8px;
                border: 1px solid #EBEBED;
                display: flex;
                /* 设置为Flex容器 */
                justify-content: center;
                /* 水平居中子元素 */
                align-items: center;
                /* 垂直居中子元素 */
                padding: 24px;
                box-sizing: border-box;
                position: relative;
                border-top: #F3F3F4 1px solid;
                margin: 14px 24px 0 0;


                .new-tag {
                    position: absolute;
                    top: -5px;
                    right: 1px;
                    width: 90px;
                    height: 22px;
                }


            }

            .center2 {
                width: 192px;
                height: 140px;
                padding: 20px 15px;
                box-sizing: border-box;
                border-radius: var(--Radius-Border-radius-4, 8px);
                border: 2px solid var(--Text-Text-4, #F4F4F5);
                background: #FFF;
                box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.10);

                .top2 {
                    width: 100%;
                    text-align: center;
                    box-sizing: border-box;
                    display: flex;
                }

                .appimgn {
                    // width: 162px;
                    max-width: 144px;
                    height: 80px;
                    margin: 0 auto;
                    margin-top: 0 !important;
                }

                .text0 {
                    color: var(--Color-Neutral-neutral-10, #64666B);
                    
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                    letter-spacing: 0.028px;
                    margin-top: 10px
                }

                .text1 {
                    color: var(--Color-Neutral-neutral-10, #64666B);
                    
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                    letter-spacing: 0.028px;
                    display: flex;
                }

                .text2 {
                    color: var(--Color-Neutral-neutral-9, #969AA0);
                    
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                    display: flex;

                }

                .text3 {
                    color: var(--Color-Branding-blue, #3461FF);
                    
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                    width: 60px;
                    text-align: right;
                    cursor: pointer;
                }
            }

            .noplatform {
                color: #BFC1C5;
                text-align: center;
                font-size: 24px;
                font-style: normal;
                font-weight: 500;
                line-height: 28px;
            }

        }





    }
}





.successtip {
    color: var(--Text-Text-10, #64666B);
    
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    padding: 0 20px;
}



.card-bottom {
    display: flex;
    justify-content: space-between;
    margin-top: 10px
}

.btn1 {
    background-color: #3461FF;
    height: 40px;
    width: 50%;
    font-size: 14px;
    border: none;
}





.btn2 {
    color: #3461FF;
    border-color: #3461FF;
    height: 40px;
    width: 50%;
    font-size: 14px;
    border: 1px solid #3461FF;
}

.btn2:hover {
    color: #fff;
    background-color: #3461FF;
    border-color: #3461FF;

}






.searchbtn {
    background-color: #3461FF;
    width: 120px;
    font-size: 14px;
    height: 32px;
    border: none;
}

.paperview-input-text {
    font-size: 14px;
    height: 32px
}

.appimgbox {

    // width: 144px;
    height: 130px;
    margin: 0 auto;
    overflow: hidden;

}








.infobox {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;

    .text-box {
        color: var(--Text-neutral-10, #64666B);
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
        height: 21px;
        padding: 0px 7px;
        border-radius: var(--Radius-Border-radius-2, 2px);
        background: linear-gradient(0deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Branding-Blue-6, #3461FF);

        overflow: hidden;
        /* 保持文本在一行内 */
        white-space: nowrap;
        /* 文本超出时显示省略号 */
        text-overflow: ellipsis;
    }

    .text-box1 {
        color: var(--Text-neutral-10, #64666B);
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
        height: 21px;
        padding: 0px 7px;
        border-radius: var(--Radius-Border-radius-2, 2px);
        background: linear-gradient(0deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Branding-Blue-6, #3461FF);
        max-width: 50px;
        overflow: hidden;
        /* 保持文本在一行内 */
        white-space: nowrap;
        /* 文本超出时显示省略号 */
        text-overflow: ellipsis;
    }


    // .info-text {
    //     color: var(--Color-Neutral-neutral-10, #64666B);
    //     
    //     font-size: 14px;
    //     font-style: normal;
    //     font-weight: 500;
    //     line-height: 22px;
    //     white-space: nowrap;
    //     overflow: hidden;
    //     text-overflow: ellipsis;
    //     // width: 100px;

    // }
}

.btnmore {
    border-radius: var(--Radius-Border-radius-3, 4px);
    border: 1px solid var(--Text-neutral-6, #DFE0E2);
    background: #FFF;
    color: var(--Text-Text-11, #323335);
    text-align: center;
    
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
    width: 122px;
    height: 40px;
    margin: 0 auto;
    cursor: pointer;
}

.btnmore:hover {
    color: #3461FF;
    border: var(--Radius-Border-radius-1, 1px) solid var(--Branding-Blue-6, #3461FF);
}

.tonext {
    width: 32px;
    height: 60px;

}

.icobox {
    font-size: 20px;
    height: 60px;
    line-height: 60px;
    width: 32px;
    text-align: center;
}

.morebox {
    width: 100%;
    text-align: center;
    height: 100px;
}

.myoverlay {
    background-color: var(--el-overlay-color-lighter);
    bottom: 0;
    height: 100%;
    left: 0;
    overflow: hidden;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 2000;
}

.mydialog {
    margin: 0 auto;
    margin-top: 200px;
    width: 1200px;
    // height: 313px;
    // height: 100%;
    padding: 64px;
    box-sizing: border-box;
    border-radius: var(--Radius-Border-radius-4, 8px);
    background: conic-gradient(from 90deg at 100% 100%, #FAFBFF 44.00728762149811deg, #F7F9FF 65.94390571117401deg, #F7FAFF 90deg, #F8FCFF 150.71987986564636deg, #ECF6FF 215.2921199798584deg);

    .dialogtitle {
        color: #000;
        text-align: center;
        
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 40px;
        // margin-top: 64px;
    }

    .numbox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        width: 90%;
        margin-top: 24px;


    }

    .dtext {
        color: #999;
        text-align: center;
        
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 40px;
        /* 250% */
    }

    .dtext2 {
        color: #999;
        text-align: center;
        
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        min-width: 150px;
    }

    .dtext3 {
        color: var(--Color-Branding-blue, #3461FF);
        
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
    }

    .dline {
        width: 100%;
        height: 1px;
        background: var(--Color-Auxiliary-auxiliary-2, #D7D7DC);
    }

}

.systeminfoBox {
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    // justify-content: center;


    /* 允许子元素换行 */
    // margin: -1px;
    /* 通过负外边距来调整边框重叠问题 */
}

.systeminfoBox2 {
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    justify-content: center;
}




.systemItem {

    box-sizing: border-box;
    border: 1px solid #D7D7DC;
    text-align: center;
    height: 40px;
    line-height: 40px;
    width: 33%;
    color: var(--Color-Neutral-neutral-11, #323335);
    text-align: center;
    width: 33.333%;
    margin-top: 17px;
    cursor: pointer;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    


}



.systemItem:hover {
    // border-color: #3461FF;
    // color: #3461FF;
    // background: #EFF9FF;
    /* 鼠标悬停时边框颜色变为蓝色 */
    z-index: 1;
    /* 提升层级，确保边框显示在上层 */
    background: #3461FF;
    color: #FFFFFF;
    border-radius: 4px;


}


.stepbox {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;


}








.bottonbox {
    display: flex;
    margin-top: 24px;
    justify-content: space-evenly;
    padding: 0 10px;
}


.bottonbox2 {
    display: flex;
    margin-top: 24px;
    padding: 0 12px;


    .btn-title {
        color: #969AA0;
        text-align: left;
        
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
    }

    .btn-text {
        color: #3461FF;
        text-align: center;
        
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        cursor: pointer;
    }
}

.bottonbox3 {
    margin-top: 24px;
    padding: 0 12px;


    .btn-title {
        color: #969AA0;
        text-align: left;
        
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        width: 100px;
    }

    .btn-text {
        color: #3461FF;
        text-align: center;
        
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        cursor: pointer;
    }
}












.point {
    color: #4E5969;
    font-size: 30px;
}


.info-text3 {
    color: var(--Text-neutral-9, #969AA0);
    
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    /* 150% */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.appimg3 {
    width: 90px;
    height: 90px;
}

.swiper-button-prev {
    width: 10px !important;
    height: 10px !important;
}




.delStep {
    color: #97A3B7;
    width: 34px;
    height: 34px;
    padding: 7px;
    border-radius: 17px;
    border: var(--Radius-Border-radius-2, 2px) solid #FFF;
    background: linear-gradient(0deg, #FFF 0%, #F3F5F8 100%);
    box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.10), -8px -8px 20px 0px rgba(255, 255, 255, 0.80);
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
}

.swiper-button-prev:after {
    display: none;
}

.swiper-button-next:after {
    font-size: 10px;
    display: none;
}

.searchBox {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    margin-top: 15px;

    .center {
        width: 192px;
        height: 140px;
        overflow: hidden;
        display: flex;
        /* 设置为Flex容器 */
        justify-content: center;
        /* 水平居中子元素 */
        align-items: center;
        /* 垂直居中子元素 */
        padding: 24px;
        box-sizing: border-box;


    }

    .center2 {
        width: 192px;
        height: 140px;
        padding: 20px 15px;
        box-sizing: border-box;
        border-radius: var(--Radius-Border-radius-4, 8px);
        border: var(--Radius-Border-radius-2, 2px) solid var(--Text-Text-4, #F4F4F5);
        background: #FFF;
        box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.10);

        .top2 {
            width: 100%;
            text-align: center;
            box-sizing: border-box;
            display: flex;
        }

        .appimgn {
            // width: 162px;
            max-width: 144px;
            height: 80px;
            margin: 0 auto;
            margin-top: 0 !important;
        }

        .text0 {
            color: var(--Color-Neutral-neutral-10, #64666B);
            
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
            letter-spacing: 0.028px;
            margin-top: 10px
        }

        .text1 {
            color: var(--Color-Neutral-neutral-10, #64666B);
            
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
            letter-spacing: 0.028px;
            display: flex;
        }

        .text2 {
            color: var(--Color-Neutral-neutral-9, #969AA0);
            
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
            display: flex;

        }

        .text3 {
            color: var(--Color-Branding-blue, #3461FF);
            
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
            width: 60px;
            text-align: right;
            cursor: pointer;
        }
    }

    .noplatform {
        color: #BFC1C5;
        text-align: center;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px;
    }
}

.mySwiper {
    padding: 10px 0 0 0;
}

.nodata {
    width: 100%;
    text-align: center;
    padding: 60px 0 40px 0;

    .text1 {
        color: var(--Text-neutral-11, #323335);
        
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
    }

    .text2 {
        color: var(--Text-neutral-9, #969AA0);
        
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        margin-top: 10px;
    }
}

.cityName {
    width: 77px;
    height: 24px;
    line-height: 24px;

    color: #fff;
    position: absolute;
    left: 0;
    bottom: 0;
    text-align: center;
    // border-radius: 0 15px 0 8px !important;
    font-size: 12px;
    background-image: url(../../assets/img/tradingSystem/city-bg.png);
    background-size: contain;
    background-repeat: no-repeat;
}
</style>